import { Injectable } from '@angular/core';
import { BackendService, AuthorizeService } from 'core-lib';
import { environment } from '../../environments/environment';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import * as moment from 'moment';
import { FileAttachmentDetailsModel } from '../components/file-upload/file-upload.component';
import { HttpClient, HttpHeaders } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class PermitService {

  constructor(private backendSvc: BackendService,
    private authSvc: AuthorizeService) { }

  public model: PermitDetailsModel;
  public modelExpiresDate: Date;

  sendValidationEmail(): Observable<any> {

    return this.backendSvc.get(`${environment.apiURL}client/permit/send-validate-email`)
      .pipe(
        catchError(err => {
          console.log(err);
          throw err;
        }),
      );
  }

  validateEmail(code: string): Observable<any> {

    return this.backendSvc.get(`${environment.apiURL}client/permit/validate-email/${code}`)
      .pipe(
        catchError(err => {
          console.log(err);
          throw err;
        }),
      );
  }

  public getDetails(forceReload?: boolean): Observable<PermitDetailsModel> {

    if (forceReload === undefined) { forceReload = false; }

    if (!forceReload && this.model && this.modelExpiresDate > moment().toDate()) {
      return of(this.model);
    }

    let url = environment.permitDetailsUrl;

    return this.backendSvc.get(url)
      .pipe(map((n: PermitDetailsResponse) => {
        this.model = n.data;
        this.modelExpiresDate = moment().add(10, 'minutes').toDate();
        return n.data;
      })
      );
  }

  getCurrentRate(): Observable<any> {

    return this.backendSvc.get(`${environment.apiURL}client/permit/current-rate`)
      .pipe(
        catchError(err => {
          console.log(err);
          throw err;
        }),
      );
  }
  getVehicles(): Observable<any> {

    return this.backendSvc.get(`${environment.apiURL}client/permit/vehicles`)
      .pipe(
        catchError(err => {
          console.log(err);
          throw err;
        }),
      );
  }

  public getBilling(filter: any): Observable<BillingDetailsResponseData> {

    let queryString = '';
    if (filter) {
      queryString = queryString + '?searchText=' + (!filter.search ? '' : filter.search);
      queryString = queryString + '&orderBy=' + (!filter.orderBy ? '' : filter.orderBy);
      queryString = queryString + '&isDesc=' + (!filter.isDesc ? 'false' : filter.isDesc ? 'true' : 'false');
      queryString = queryString + '&skip=' + (!filter.skip ? '0' : filter.skip);
      queryString = queryString + '&take=' + (!filter.take ? '0' : filter.take);
    }
    let url = environment.billingDetailsUrl + queryString;

    return this.backendSvc.get(url)
      .pipe(map((n: BillingDetailsResponse) => {
        return n.data;
      }));
  }


  public getTransactions(filter: any): Observable<TransactionDetailsResponseData> {

    let queryString = '';
    if (filter) {
      queryString = queryString + '?searchText=' + (!filter.search ? '' : filter.search);
      queryString = queryString + '&transactionId=' + (!filter.transactionId ? '' : filter.transactionId);
      queryString = queryString + '&permitNumber=' + (!filter.permitNo ? '' : filter.permitNo);
      queryString = queryString + '&transactionType=' + (!filter.transactionType ? '' : filter.transactionType);
      queryString = queryString + '&location=' + (!filter.location ? '' : filter.location);
      queryString = queryString + '&vehicleNumber=' + (!filter.regoNo ? '' : filter.regoNo);
      queryString = queryString + '&volume=' + (!filter.volume ? '' : filter.volume);
      queryString = queryString + '&startDate=' + (!filter.startDate ? '' : filter.startDate);
      queryString = queryString + '&endDate=' + (!filter.endDate ? '' : filter.endDate);
      queryString = queryString + '&orderBy=' + (!filter.orderBy ? '' : filter.orderBy);
      queryString = queryString + '&isDesc=' + (!filter.isDesc ? 'false' : filter.isDesc ? 'true' : 'false');
      queryString = queryString + '&skip=' + (!filter.skip ? '0' : filter.skip);
      queryString = queryString + '&take=' + (!filter.take ? '0' : filter.take);
    }

    let url = environment.transactionListUrl + queryString;

    return this.backendSvc.get(url)
      .pipe(map((n: TransactionDetailsResponse) => {
        return n.data;
      }));
  }

  public updatePermit(data: PermitDetailsItemModel): Observable<PermitDetailsModel> {

    let url = environment.permitUpdateUrl + '/' + data.permitId;

    return this.backendSvc.put(url, data)
      .pipe(map((n: PermitUpdateResponse) => {
        return n.data;
      }));
  }

  public createWaterUsage(data: WaterUsageItemModel): Observable<WaterUsageCreateResponseData> {
    // 'client/waterusage
    return this.backendSvc.post(environment.waterUsageCreateUrl, data)
      .pipe(map((n: WaterUsageCreateResponse) => {
        return n.data;
      }));

  }

  public updateWaterUsage(data: WaterUsageItemModel): Observable<WaterUsageCreateResponseData> {
  // 'client/waterusage
    return this.backendSvc.put(environment.waterUsageCreateUrl, data)
      .pipe(map((n: WaterUsageCreateResponse) => {
        return n.data;
      }));

  }

  public changePassword(newPassword: string): Observable<boolean> {

    let data = {
      userId: this.authSvc.userId,
      password: newPassword
    };

    return this.backendSvc.post(environment.changePasswordUrl, data)
      .pipe(map((n: ChangePasswordResponse) => {
        return true;
      }));

  }

  public renewPermit(permitId: string, vehicleIds: string[]): Observable<boolean> {

    let url = environment.permitRenewUrl + '/' + permitId;

    return this.backendSvc.put(url, { vehicleIds })
      .pipe(map((n: PermitRenewResponse) => {
        return true;
      }));
  }

  public requestVehicleRemoval(vehicleId: string): Observable<boolean> {
    let url = environment.removeVehicleUrl + '/' + vehicleId;

    return this.backendSvc.delete(url)
      .pipe(map((n: RemoveVehicleResponse) => {
        return true;
      }));
  }

  public sendEmailToAdmin(subject: string, message: string): Observable<boolean> {
    let data = { subject, message };

    return this.backendSvc.post(environment.sendEmailToAdminUrl, data)
      .pipe(map((n: SendEmailToAdminResponse) => {
        return true;
      }));
  }

  public createVehicle(data: any): Observable<boolean> {
    let url = environment.createVehicleUrl;

    return this.backendSvc.post(url, data).pipe(map((n: any) => {
      return true;
    }));

  }

  public updateVehicle(data: any): Observable<boolean> {
    let url = environment.updateVehicleUrl + '/' + data.vehicleId;

    return this.backendSvc.put(url, data).pipe(map((n: any) => {
      return true;
    }));

  }

}


class WaterUsageCreateResponse {
  public code: number;
  public message: string;
  public data: WaterUsageCreateResponseData;
}

class RemoveVehicleResponse {
  public code: number;
  public message: string;
}
export class WaterUsageCreateResponseData {
  public item: WaterUsageItemModel;
}

export class WaterUsageItemModel {
  public waterUsageId: string;
  public vehicleId: string;
  public permitId: string;
  public usageDate: string;
  public location: string;
  public fillLoads: number;
  public fillLitres: number;
  public fillType: string;
  public usageRate: number;
  public usageCost: number;
  public usageTotal: number;
  public isDoNotBill: boolean;
  public statusCode: string;
  public comment: string;
  public isBulk: boolean;
  public isCreatedByAdmin: boolean;

  constructor() {
    this.fillLoads = 0;
    this.fillLitres = 0;
  }
}

export class PermitRenewResponse {
  public code: number;
  public message: string;
}

class PermitDetailsResponse {
  public code: number;
  public message: string;
  public data: PermitDetailsModel;
}

export class PermitDetailsModel {
  public permitDetails: PermitDetailsItemModel;
  public vehicles: PermitDetailsVehicleItemModel[];
  public transactions: PermitDetailsTransactionItemModel[];
  public transactionCount: number;
  public billingPeriods: PermitDetailsBillingItemModel[];
  public billingPeriodsCount: number;
  public businessTypes: BusinessTypeItemModel[];
  public currentMonth: PermitDetailsBillingItemModel;
  public lastMonth: PermitDetailsBillingItemModel;
  public currentRates: RatesItem;
  public iosLink: string;
  public androidLink: string;
}

export class PermitDetailsItemModel {
  public permitId: string;
  public permitNo: string;
  public fileNo: string;
  public hiAffinityNo: string;
  public clientId: string;
  public clientName: string;
  public abn: string;
  public firstName: string;
  public lastName: string;

  public isSameAddress: boolean;

  public address1: string;
  public address2: string;
  public suburb: string;
  public state: string;
  public postCode: string;
  public isAddressNotFound: boolean;

  public billingAddress1: string;
  public billingAddress2: string;
  public billingSuburb: string;
  public billingState: string;
  public billingPostCode: string;
  public isBillingAddressNotFound: boolean;

  public email: string;
  public isEmailValidated: boolean;

  public mobilePhone: string;
  public workPhone: string;
  public businessTypeId: string;
  public businessTypeOther: string;
  public comment: string;

  public status: string;
  public expiryDate: string;
  public startDate: string;
  public cancelDate: string;

  public isEmsKey: boolean;
  public emsKeys: EmsKey[];
}

export class EmsKey
{
  public emsKeyId: string;
  public emsNo: string;
}
export class PermitDetailsVehicleItemModel {
  public vehicleId: string;
  public rego: string;
  public regoState: string;
  public capacity: number;
  public vehicleType: string;
  public vehicleMake: string;
  public vehicleMakeId: string;
  public vehicleTypeId: string;
  public startDate: string;
  public endDate: string;
  public lineNo: number;
  public hasDevice: boolean;
  public comment: string;
  public status: string;

  public deviceId: string;
  public deviceNo: string;
  public imei: string;
  public commissionDate: string;
  public removalDate: string;

  public isAirGap: boolean;
  public isRPZD: boolean;
  public backflowPreventionCertificateIssueDate: string;

  public isRemovalRequested: boolean;
  public removalRequestedDate: string;

  public attachments: any[];
}

export class PermitDetailsTransactionItemModel {
  public transactionId: string;
  public transactionType: string;
  public fillDate: string;
  public volume: number;
  public fillType: string;
  public cost: number;
  public regoNo: string;
  public location: string;
  public isOutOfBillableArea: boolean;
  public dupeCount: number;
  public isDoNotBill: boolean;
  public comment: string;
  public status: string;
  public isCreatedByAdmin: boolean;
  public isNoLocation: boolean;
  public latitude: number;
  public longitude: number;
  public isAttachmentsShown: boolean;
  public attachments: FileAttachmentDetailsModel[];
}


class BillingDetailsResponse {
  public code: number;
  public message: string;
  public data: BillingDetailsResponseData;
}

export class BillingDetailsResponseData {
  public items: PermitDetailsBillingItemModel[];
  public totalCount: number;
}

class TransactionDetailsResponse {
  public code: number;
  public message: string;
  public data: TransactionDetailsResponseData;
}

export class TransactionDetailsResponseData {
  public items: PermitDetailsTransactionItemModel[];
  public totalCount: number;
}


export class PermitDetailsBillingItemModel {
  public billingPeriodId: string;

  public startDate: Date;
  public endDate: Date;
  public permitFee: number;
  public loggerUsage: number;
  public manualUsage: number;
  public emsUsage: number;
  public total: number;
  public rolledOver: number;
}


export class BusinessTypeItemModel {
  public businessTypeId: string;
  public description: string;
}

export class RatesItem {
  public rateId: string;
  public startDate: string;
  public endDate: string;
  public permitRate: number;
  public usageRate: number;
}

class PermitUpdateResponse {
  public code: number;
  public message: string;
  public data: PermitDetailsModel;
}

class ChangePasswordResponse {
  public code: number;
  public message: string;
}

class SendEmailToAdminResponse {
  public code: number;
  public message: string;
}

export class CreateVehicleModel {

  public vehicleId: string;
  public permitId: string;
  public rego: string;
  public capacity: number;
  public vehicleTypeId: string;
  public vehicleMakeId: string;
  public vehicleType: string;
  public vehicleMake: string;

  public state: string;
  public comment: string;
  public startDate: any;
  public proRataStartDate: any;
  public endDate: any;

  public hasDevice: boolean;

  public isAirGap: boolean;
  public isRPZD: boolean;
  public backFlowPreventionCertificateIssueDate: string;
  public isLogSheets: boolean;

  public attachmentIds: string[];
}
